<template>
    <div class="acao-botao-container">
        <ItemMenuWrapper v-slot="{ inputId }" label="Ação do Botão">
            <Dropdown
                :id="inputId"
                v-model="selectedAction"
                :options="acoes"
                optionLabel="label"
                optionValue="value"
                @change="handleActionChange"
                class="w-full"
            />
        </ItemMenuWrapper>

        <div class="mt-3">
            <div v-if="selectedAction === 'link'">
                <ItemMenuWrapper label="URL de Destino" v-slot="{ inputId }">
                    <InputText :id="inputId" v-model="campos.url" @update:modelValue="handleFieldChange" class="w-full" />
                </ItemMenuWrapper>
                <ItemMenuWrapper label="Abrir em nova aba" v-slot="{ inputId }">
                    <div class="flex align-items-center">
                        <Checkbox :id="inputId" v-model="campos.novaAba" :binary="true" @change="handleFieldChange" />
                        <label :for="inputId" class="flex align-items-center cursor-pointer">
                            <span class="ml-2">{{ campos.novaAba ? 'Sim' : 'Não' }}</span>
                        </label>
                    </div>
                </ItemMenuWrapper>
            </div>

            <div v-if="selectedAction === 'scroll'">
                <ItemMenuWrapper v-slot="{ inputId }" label="Destino do Scroll">
                    <Dropdown
                        :id="inputId"
                        v-model="campos.elemento"
                        :options="elementosDisponiveis"
                        optionLabel="label"
                        optionValue="value"
                        @change="handleFieldChange"
                        class="w-full"
                        placeholder="Selecione o destino"
                    />
                </ItemMenuWrapper>
            </div>

            <div v-if="selectedAction === 'email'">
                <ItemMenuWrapper v-slot="{ inputId }" label="Destinatário(s)">
                    <InputText
                        :id="inputId"
                        v-model="campos.destinatario"
                        @update:modelValue="handleFieldChange"
                        class="w-full"
                        placeholder="email@exemplo.com"
                    />
                </ItemMenuWrapper>
                <ItemMenuWrapper v-slot="{ inputId }" label="Assunto">
                    <InputText :id="inputId" v-model="campos.assunto" @update:modelValue="handleFieldChange" class="w-full" />
                </ItemMenuWrapper>
                <ItemMenuWrapper v-slot="{ inputId }" label="Corpo do E-mail">
                    <Textarea :id="inputId" v-model="campos.corpo" @update:modelValue="handleFieldChange" rows="3" class="w-full" />
                </ItemMenuWrapper>
            </div>

            <div v-if="selectedAction === 'whatsapp'">
                <ItemMenuWrapper v-slot="{ inputId }" label="Número de Telefone">
                    <InputMask :id="inputId" v-model="campos.numero" mask="+99 (99) 99999-9999" @update:modelValue="handleFieldChange" class="w-full" />
                </ItemMenuWrapper>
                <ItemMenuWrapper v-slot="{ inputId }" label="Mensagem Padrão">
                    <Textarea :id="inputId" v-model="campos.mensagem" @update:modelValue="handleFieldChange" rows="3" class="w-full" />
                </ItemMenuWrapper>
            </div>

            <div v-if="selectedAction === 'telefone'">
                <ItemMenuWrapper v-slot="{ inputId }" label="Número de Telefone">
                    <InputMask :id="inputId" v-model="campos.numero" mask="+99 (99) 99999-9999" @update:modelValue="handleFieldChange" class="w-full" />
                </ItemMenuWrapper>
            </div>

            <div v-if="selectedAction === 'instagram'">
                <ItemMenuWrapper label="Usuário do Instagram" v-slot="{ inputId }">
                    <InputText :id="inputId" v-model="campos.url" @update:modelValue="handleFieldChange" class="w-full" placeholder="Ex: @seuusuario" />
                </ItemMenuWrapper>
            </div>

            <div v-if="selectedAction === 'linkedin'">
                <ItemMenuWrapper label="URL do Perfil no LinkedIn" v-slot="{ inputId }">
                    <InputText :id="inputId" v-model="campos.url" @update:modelValue="handleFieldChange" class="w-full" placeholder="Ex: /in/seu-perfil-aqui" />
                </ItemMenuWrapper>
            </div>

            <div v-if="selectedAction === 'twitter'">
                <ItemMenuWrapper label="Usuário do Twitter" v-slot="{ inputId }">
                    <InputText :id="inputId" v-model="campos.url" @update:modelValue="handleFieldChange" class="w-full" placeholder="Ex: @seuperfil" />
                </ItemMenuWrapper>
            </div>

            <div v-if="selectedAction === 'facebook'">
                <ItemMenuWrapper label="URL do Perfil no Facebook" v-slot="{ inputId }">
                    <InputText :id="inputId" v-model="campos.url" @update:modelValue="handleFieldChange" class="w-full" placeholder="Ex: /suapagina" />
                </ItemMenuWrapper>
            </div>
        </div>
    </div>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineProps, defineEmits, ref, computed, watch } from 'vue';
import InputMask from 'primevue/inputmask';
import Textarea from 'primevue/textarea';
import Checkbox from 'primevue/checkbox';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';

const props = defineProps({
    modelValue: {
        type: Object,
        default: () => ({ acao: 'link', campos: {} }),
    },
});

const emit = defineEmits(['update:modelValue']);

const acoes = [
    { label: 'Abrir um link', value: 'link' },
    { label: 'Enviar um E-mail', value: 'email' },
    { label: 'Abrir WhatsApp', value: 'whatsapp' },
    { label: 'Fazer uma ligação', value: 'telefone' },
    { label: 'Rolar para um elemento', value: 'scroll' },
    { label: 'Abrir link do Instagram', value: 'instagram' },
    { label: 'Abrir link do LinkedIn', value: 'linkedin' },
    { label: 'Abrir link do Twitter', value: 'twitter' },
    { label: 'Abrir link do Facebook', value: 'facebook' },
];

const selectedAction = ref(props.modelValue.acao || 'link');
const campos = ref(props.modelValue.campos || {});

watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal) {
            selectedAction.value = newVal.acao || 'link';
            campos.value = newVal.campos || {};
        }
    },
    { immediate: true }
);

const elementosDisponiveis = computed(() => {
    return [
        { label: 'Topo da Página', value: 'cabecalho' },
        { label: 'Formulário de Inscrição', value: 'formulario' },
        { label: 'Final da Página', value: 'rodape' },
    ];
});

const handleActionChange = () => {
    if (selectedAction.value === 'scroll') {
        campos.value = { elemento: 'cabecalho' };
    } else {
        campos.value = {};
    }
    emitUpdate();
};

const handleFieldChange = () => {
    emitUpdate();
};

const emitUpdate = () => {
    const dadosParaEmitir = {
        acao: selectedAction.value,
        campos: { ...campos.value },
    };
    emit('update:modelValue', dadosParaEmitir);
};
</script>
